import { createContext, useState, type Dispatch, type SetStateAction, type ReactNode } from 'react';

export type WeatherStation = {
  station: string;
  alt: number;
  coordinate: {
    x: number;
    y: number;
  };
  jan: number;
  feb: number;
  mar: number;
  apr: number;
  may: number;
  jun: number;
  jul: number;
  aug: number;
  sep: number;
  oct: number;
  nov: number;
  dec: number;
  avgYear: number;
  avgDir: number;
  measurementHeight: number;
  [key: string]: unknown;
};

export type ClosestStation = WeatherStation | null;

export interface ClosestStationContextValue {
  closestStation: ClosestStation;
  setClosestStation: Dispatch<SetStateAction<ClosestStation>>;
  loadingClosestStation: boolean;
  setLoadingClosestStation: Dispatch<SetStateAction<boolean>>;
  initialClosestStation: ClosestStation;
  setInitialClosestStation: Dispatch<SetStateAction<ClosestStation>>;
}

export const ClosestStationContext = createContext<ClosestStationContextValue>({} as ClosestStationContextValue);

interface ClosestStationContextProviderProps {
  children: ReactNode;
}

const ClosestStationContextProvider = (props: ClosestStationContextProviderProps) => {
  const [closestStation, setClosestStation] = useState<ClosestStation>(null);
  const [loadingClosestStation, setLoadingClosestStation] = useState(true);
  const [initialClosestStation, setInitialClosestStation] = useState<ClosestStation>(null);

  return (
    <ClosestStationContext.Provider
      value={{
        closestStation,
        setClosestStation,
        loadingClosestStation,
        setLoadingClosestStation,
        initialClosestStation,
        setInitialClosestStation,
      }}
    >
      {props.children}
    </ClosestStationContext.Provider>
  );
};

export default ClosestStationContextProvider;
